import { businessClockGuard } from './core/time/business-clock-ui';
import { Routes } from '@angular/router';
import { FullLayoutComponent } from './shared/components/full-layout/full-layout.component';
import { authGuard, publicOnlyGuard } from './core/guards/auth.guard';

import { LoginComponent } from './features/login/login.component';
import { ResetPasswordComponent } from './features/reset-password/reset-password.component';
import { ResetPasswordEditComponent } from './features/reset-password-edit/reset-password-edit.component';
import { TopComponent } from './features/top/top.component';
import { ErrorComponent } from './features/error/error.component';
import { UnauthorizedComponent } from './features/unauthorized/unauthorized.component';
import { TransactionComponent } from './features/transaction/transaction.component';
import { MemberComponent } from './features/member/member.component';
import { InoutComponent } from './features/inout/inout.component';
import { InoutQrComponent } from './features/inout-qr/inout-qr.component';
import { NotificationComponent } from './features/notification/notification.component';
import { NotificationPlanComponent } from './features/notification-plan/notification-plan.component';
import { NotificationPaymentComponent } from './features/notification-payment/notification-payment.component';
import { PersonalComponent } from './features/personal/personal.component';
import { CounselComponent } from './features/counsel/counsel.component';
import { CounselItemComponent } from './features/counsel-item/counsel-item.component';
import { CounselPhotoComponent } from './features/counsel-photo/counsel-photo.component';
import { ProgramComponent } from './features/program/program.component';
import { ProgramListComponent } from './features/program-list/program-list.component';
import { ProgramItemComponent } from './features/program-item/program-item.component';
import { PtReservationComponent } from './features/pt-reservation/pt-reservation.component';

export const routes: Routes = [
  // Public routes (no layout wrapper — SimpleLayoutComponent was just <router-outlet>)
  { path: 'login', component: LoginComponent, canActivate: [publicOnlyGuard] },
  { path: 'reset-password', component: ResetPasswordComponent, canActivate: [publicOnlyGuard] },
  { path: 'reset-password/:token', component: ResetPasswordEditComponent, canActivate: [publicOnlyGuard] },

  // Authenticated routes under FullLayoutComponent
  {
    path: '',
    component: FullLayoutComponent,
    canActivate: [authGuard],
    children: [
      { path: '', redirectTo: 'top', pathMatch: 'full' },
      { path: 'top', component: TopComponent },
      { path: 'error', component: ErrorComponent },
      { path: 'unauthorized', component: UnauthorizedComponent },
      { path: 'transaction', canActivate: [businessClockGuard], component: TransactionComponent },
      { path: 'member', component: MemberComponent },
      { path: 'inout', canActivate: [businessClockGuard], component: InoutComponent },
      { path: 'inout-qr', component: InoutQrComponent },
      { path: 'notification', canActivate: [businessClockGuard], component: NotificationComponent },
      { path: 'notification/plan', canActivate: [businessClockGuard], component: NotificationPlanComponent },
      { path: 'notification/payment', canActivate: [businessClockGuard], component: NotificationPaymentComponent },
      { path: 'personal', component: PersonalComponent },
      { path: 'counsel', canActivate: [businessClockGuard], component: CounselComponent },
      { path: 'counsel/photo', component: CounselPhotoComponent },
      { path: 'counsel/:counselId', canActivate: [businessClockGuard], component: CounselItemComponent },
      { path: 'program', component: ProgramComponent },
      { path: 'program/item/:uploadedPdf', component: ProgramItemComponent },
      { path: 'program/:level', component: ProgramListComponent },
      { path: 'pt-reservation', canActivate: [businessClockGuard], component: PtReservationComponent },
      { path: 'pt_reservation', canActivate: [businessClockGuard], component: PtReservationComponent },
    ],
  },

  { path: '**', redirectTo: 'login' },
];
